import { authenticated } from './WebRequest';
import { omitNil } from 'js/mylib/Utils';
import type {
  ApiThunk,
  BackupMessageResponse,
  BackupNowParameters,
  BackupSettingsParameters,
  BackupSettingsResponse,
} from './types/Backup';

export type {
  ApiThunk,
  BackupLastState,
  BackupMessageResponse,
  BackupNowParameters,
  BackupRequestParameters,
  BackupSchedule,
  BackupSettings,
  BackupSettingsParameters,
  BackupSettingsResponse,
  BackupStatusResponse,
} from './types/Backup';

export function backup_settings(): ApiThunk<BackupSettingsResponse> {
  return authenticated.get('/server/backup_settings');
}

export function backup_now(
  parameters: BackupNowParameters
): ApiThunk<BackupMessageResponse> {
  const { ...params } = omitNil(parameters);
  return authenticated.post('/server/backup_now', {
    params,
  });
}

export function set_backup_settings(
  parameters: BackupSettingsParameters
): ApiThunk<BackupMessageResponse> {
  const { ...params } = omitNil(parameters);
  return authenticated.post('/server/set_backup_settings', {
    params,
  });
}
